import MuiButton from '@mui/material/Button';

import styles from './button.module.scss';
import PropTypes from 'prop-types';

const Button = ({ title, size = 'medium', onClick }) => {
    return (
        <MuiButton onClick={onClick} className={styles.root} variant="contained" size={size}>
            {title}
        </MuiButton>
    );
};

Button.propTypes = {
    title: PropTypes.string,
    size: PropTypes.oneOf(['medium']),
    onClick: PropTypes.func
};

export default Button;
